import { render, staticRenderFns } from "./WebinarTehnic.vue?vue&type=template&id=5d083c78&"
import script from "./WebinarTehnic.vue?vue&type=script&lang=js&"
export * from "./WebinarTehnic.vue?vue&type=script&lang=js&"
import style0 from "./WebinarTehnic.vue?vue&type=style&index=0&id=5d083c78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports